import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EmployerAnalytics extends ApplicationRecord {
  static jsonapiType = "employer_analytics";

  @Attr() fillRate: {
    totalJobsPosted: number;
    filledByPsl: number;
    filledByMarketplace: number;
  };

  @Attr() placementSummary: {
    totalFillRate: number;
    pslFillRate: number;
    marketplaceFillRate: number;
  };

  @Attr() timeToSubmission: {
    averageHoursFromPsl: number;
    averageHoursFromMarketplace: number;
  };
}

export default EmployerAnalytics;
